/**
 * @generated SignedSource<<e40365378a1e984542b41da7030c464d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NewsletterSubscriberInput = {
  append?: boolean | null | undefined;
  mail: string;
  subscriptions?: ReadonlyArray<NewsletterSubscriptionsFieldInput | null | undefined> | null | undefined;
};
export type NewsletterSubscriptionsFieldInput = {
  source?: string | null | undefined;
  status?: string | null | undefined;
  targetId: string;
  timestamp?: string | null | undefined;
};
export type apisSignUpNewslettersApiMutation$variables = {
  input?: NewsletterSubscriberInput | null | undefined;
};
export type apisSignUpNewslettersApiMutation$data = {
  readonly upsertNewsletterSubscriber: {
    readonly entity: {
      readonly subscriptions?: ReadonlyArray<{
        readonly entity: {
          readonly entityId: string | null | undefined;
          readonly entityLabel: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly uid?: {
        readonly entity: {
          readonly uid: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<string | null | undefined> | null | undefined;
  };
};
export type apisSignUpNewslettersApiMutation = {
  response: apisSignUpNewslettersApiMutation$data;
  variables: apisSignUpNewslettersApiMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SimplenewsSubscriberUid",
      "kind": "LinkedField",
      "name": "uid",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SimplenewsSubscriberUidEntity",
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SimplenewsSubscriberSubscription",
      "kind": "LinkedField",
      "name": "subscriptions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SimplenewsSubscriberSubscriptionEntity",
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SimplenewsSubscriber",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apisSignUpNewslettersApiMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EntityCrudOutput",
        "kind": "LinkedField",
        "name": "upsertNewsletterSubscriber",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apisSignUpNewslettersApiMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EntityCrudOutput",
        "kind": "LinkedField",
        "name": "upsertNewsletterSubscriber",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1fb3fb9786fa62f38926c967a5046b9b",
    "id": null,
    "metadata": {},
    "name": "apisSignUpNewslettersApiMutation",
    "operationKind": "mutation",
    "text": "mutation apisSignUpNewslettersApiMutation(\n  $input: NewsletterSubscriberInput\n) {\n  upsertNewsletterSubscriber(input: $input) {\n    entity {\n      __typename\n      ... on SimplenewsSubscriber {\n        uid {\n          entity {\n            uid\n          }\n        }\n        subscriptions {\n          entity {\n            entityId\n            entityLabel\n          }\n        }\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c5f8eda66218d275fb91bd0162382c4";

export default node;
